// extracted by mini-css-extract-plugin
export default {"warning":"WrongPatientWarning_warning__6S3dy","deets":"WrongPatientWarning_deets__wnWAd"};